import { Component, inject } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { AuthStateService } from '../../core/services/auth-state.service';
import { SocketService } from '../../core/services/socket.service';

@Component({
    selector: 'app-login',
    imports: [FormsModule, RouterLink],
    templateUrl: './login.component.html'
})
export class LoginComponent {
  private http = inject(HttpClient);
  private authState = inject(AuthStateService);
  private socketService = inject(SocketService);
  private router = inject(Router);
  private toastr = inject(ToastrService);

  member = { loginId: '', password: '' };
  loginError = false;
  errorMessage = '';

  async login(): Promise<void> {
    if (!this.member.loginId || !this.member.password) return;
    this.loginError = false;
    try {
      const res = await firstValueFrom(
        this.http.post<any>(`${environment.apiBaseUrl}/member/auth`, this.member, {
          withCredentials: true,
          headers: { '__skipAuthInterceptor': 'true' },
        })
      );
      if (res?.success && res?.result?.token) {
        this.authState.currentMember = res.result;
        this.socketService.connect();
        const returnTo = this.authState.returnToPath;
        this.authState.returnToPath = null;
        this.router.navigate([returnTo || '/top']);
      } else {
        this.loginError = true;
        this.errorMessage = 'ログインIDまたはパスワードが間違っています。';
      }
    } catch (err: any) {
      this.loginError = true;
      if (err?.status === 401) {
        this.errorMessage = 'ログインIDまたはパスワードが間違っています。';
      } else {
        this.errorMessage = 'サーバーとの通信に失敗しました。時間をおいて再度お試しください。';
      }
    }
  }
}
